import type { DbRow } from "./seed";

export function dbText(row: DbRow, key: string, fallback = ""): string {
  const value = row[key];
  if (value === null || value === undefined) {
    return fallback;
  }
  return String(value);
}

export function dbNullableText(row: DbRow, key: string): string | null {
  const value = row[key];
  if (value === null || value === undefined) {
    return null;
  }
  return String(value);
}

export function dbNumber(row: DbRow, key: string, fallback = 0): number {
  const value = Number(row[key]);
  return Number.isFinite(value) ? value : fallback;
}

export function dbBool(row: DbRow, key: string): boolean {
  return Boolean(row[key]);
}

export function dbNumberList(row: DbRow, key: string): number[] {
  const value = row[key];
  if (!Array.isArray(value)) {
    return [];
  }
  return value.map(item => Number(item)).filter(Number.isFinite);
}
